import React from 'react';
import Typography from 'kingpin/atoms/Typography';
import Button from 'kingpin/atoms/Button';
import Row from 'components/Common/Row';
import UserFromId from '../../../../../components/UserFromId';

const LastUpdatedBy = ({ userId }: { userId?: string }) => {
  if (!userId) {
    return null;
  }

  return (
    <Row centerAlign>
      <div style={{ marginRight: 8, display: 'flex' }}>
        <Typography.Body type="Body 12">Last updated by:</Typography.Body>
      </div>
      <UserFromId userId={userId} />
    </Row>
  );
};

const Headings = ({
  filter,
  close,
  onEditClicked,
}: {
  filter: SavedFilter | DefaultDatasetFilter;
  close: () => void;
  onEditClicked: () => void;
}) => {
  return (
    <div style={{ marginBottom: 8 }}>
      <Row spaceBetween style={{ marginBottom: 12 }} centerAlign>
        <Row centerAlign>
          <div style={{ marginRight: 12 }}>
            <Typography.Header type="H2">{filter.name}</Typography.Header>
          </div>
        </Row>
        <Row>
          <div style={{ marginRight: 8 }}>
            <Button
              label="Edit Filter"
              onClick={onEditClicked}
              size="Small"
              type="Primary"
            />
          </div>

          <div>
            <Button
              onClick={close}
              icon="cross"
              type="Secondary"
              size="Small"
            />
          </div>
        </Row>
      </Row>
      <LastUpdatedBy userId={filter.updatedBy} />
    </div>
  );
};

export default Headings;
